<template>
  <div class="webdatalist">
    <f7-list media-list accordion class="searchbar-found" id="bank-list">

      <div class="showSmallScreenOnly">
        <ul>
          <!-- TLV 09/01/2020
            Sur les petits écrans, un clic sur la demande affiche le statement (pendant qu'un swipe gère default, edit et delte)
          -->
          <li v-for="account in bankAccounts" :key="account.id" class="swipeout" v-on:click="openFormListStatement(account)">
            <div class="item-content swipeout-content">
              <div class="item-media">
                <i class='icon list-icon icon-credit_card'></i>
              </div>
              <div class="item-inner">
                <div class="item-title">{{ account.name }}</div>
                <div class="item-after defaultLabel">{{ isDefaultLabel(account.isDefault) }}</div>
                <div class="item-subtitle">
                  <div v-for="accountData in formatIban(account.iban, account.zoneCode)">
                    {{ $t(accountData.labelId) }} : {{ accountData.hiddenValue }}
                  </div>
                </div>
              </div>
            </div>
            <div class="swipeout-actions-right">
              <a href="#" class="action1" v-on:click="setDefaultBanqueAccount(account, $event)">
                {{ $t('bank_accounts.set_default_account') }}
              </a>
              <a class="swipeout-create action3" href="#" v-on:click="modifyBanqueAccount(account, $event)">
                {{ $t('common.edit_label') }}
              </a>
              <a class="swipeout-delete action4" href="#" v-on:click="removeBankAccount(account.id, $event)" delete>
                {{ $t('common.rm_label') }}
              </a>
            </div>
          </li>
        </ul>
      </div>

      <div class="showLargeScreenOnly">
        <ul>
          <li v-for="account in bankAccounts" :key="account.id" class="bankAccountList">
            <div class="item-content boxRequest" @click="openFormListStatement(account)">
              <div class="item-media">
                <i class='icon list-icon icon-credit_card'></i>
              </div>
              <div class="item-inner">
                <div class="item-title">
                  {{ account.name }}
                </div>
              </div>
              <div class="item-subtitle bankIban" :class="{bankIbanLarge: SmallOnLargeScreen}">
                <div v-for="accountData in formatIban(account.iban, account.zoneCode)">
                  {{ $t(accountData.labelId) }} : {{ accountData.hiddenValue }}
                </div>
              </div>
              <div class="item-after defaultLabel" :class="{defaultLabelLarge: SmallOnLargeScreen}">{{ isDefaultLabel(account.isDefault) }}</div>
              <div class="item-media button-swipe-out" style="margin-right: 100px;">
                <button
                  class="button-big button-bank-account button-bank-account-phone-left boxRequest"
                  title="Default"
                  v-on:click="setDefaultBanqueAccount(account, $event)">
                  <i class="icon fa fa-plus"></i>
                </button>
                <button
                  class="button-big button-bank-account boxRequest"
                  title="View statement"
                  v-on:click="openFormListStatement(account)">
                  <i class="icon fa fa-euro"></i>
                </button>
                <button
                  class="button-big button-bank-account boxRequest"
                  title="Modify"
                  v-on:click="modifyBanqueAccount(account, $event)">
                  <i class="icon-edit icon icon-float-sub-button"></i>
                </button>
                <button
                  class="button-big button-bank-account button-bank-account-phone-right boxRequest"
                  title="Remove"
                  v-on:click="removeBankAccount(account.id, $event)">
                  <i class="fa fa-times-circle button-delete" style="margin-bottom: 0.5%; color: red;"></i>
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </f7-list>
</div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import {extractForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'BankAccountList',
  props: ['bankAccounts', 'filterBy', 'SmallOnLargeScreen'],
  data () {
    return {
      extractedBankData: {}
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    displayOnVoid (val) {
      if (val == null || val === '') {
        return 'Empty'
      } else {
        return val
      }
    },
    modifyBanqueAccount (account, e) {
      e.stopPropagation()
      this.$bus.emit('edit-bank-account', account)
      // this.$f7.popup('#EditBankAccount')
      this.$engine.settings.set({modifyAccount: account})
      loadPage(this, {url: '/bankAccounts/modify/'})
    },
    removeBankAccount (id, e) {
      e.stopPropagation()
      const that = this
      that.$f7.confirm(this.$i18n.t('bank_accounts.delete_act_confirmation'),
        this.$i18n.t('common.oper_confirm'), function () {
          that.$engine.bankAccounts
            .del(id)
            .then(() => {
              that.$f7.modal({
                title: that.$i18n.t('bank_accounts.deleted_act'),
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.bankAccounts = that.bankAccounts.filter(function (value, index, arr) { return value.id !== id })
                that.$f7.closeModal()
                loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
              }, 2000)
            })
            .catch(err => {
              this.handleError(err) // mixins errorHandlerMixins
            })
        })
    },
    openFormListStatement (account) {
      this.$engine.bankAccounts.setIbanStatment(account.iban)
      this.$bus.emit('refresh-bank-accounts-list-statement')
      loadPage(this, {url: '/bankAccounts/listStatement/'})
    },
    setDefaultBanqueAccount (account, e) {
      e.stopPropagation()
      let that = this
      let isDefaultValue = ''
      if (account.isDefault === '0') {
        isDefaultValue = '1'
      } else if (account.isDefault === '1') {
        isDefaultValue = '0'
      }
      this.$engine.bankAccounts
        .update({
          id: account.id,
          name: account.name,
          iban: account.iban,
          qxban: '',
          isDefault: isDefaultValue,
          zoneCode: account.zoneCode
        })
        .then(() => {
          this.$f7.modal({
            title: this.$i18n.t('bank_accounts.default_act_setted'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.name = ''
            that.iban = ''
            that.id = 0
            that.$bus.$emit('refresh-bank-accounts')
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
    },
    isDefaultLabel (isDefault) {
      if (isDefault === '1') {
        return this.$i18n.t('bank_accounts.default_act_label')
      } else {
        return ''
      }
    },
    formatIban (iban, zone) {
      return extractForeignIban(iban, zone)
    }
  }
}
</script>

<style scoped>
.bankAccountList>.item-link>.item-content>.item-inner>.item-title-row>.item-title {
  color: #12bcf1 !important;
}
@media (max-width: 768px) {
  .scrollbar {
      height: 165%;
    }
  }
@media (min-width: 1200px) {
  .item-inner {
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// CMBankAccountsList.vue?df215aea